<template>
  <div class="activities-manage-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('activitiesSignUpManage.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0;" @click="_moreCondition">
          {{ activitiesSignUpManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="activitiesSignUpManageInfo.conditions.userName"
                    :placeholder="$t('activitiesSignUpManage.search.userName')" clearable />
        </el-col>
        <el-col :span="4">
          <el-input v-model="activitiesSignUpManageInfo.conditions.userTel"
                    :placeholder="$t('activitiesSignUpManage.search.userTel')" clearable />
        </el-col>
        <el-col :span="4">
          <el-input v-model="activitiesSignUpManageInfo.conditions.activitiesTitle"
                    :placeholder="$t('activitiesSignUpManage.search.activitiesTitle')" clearable />
        </el-col>
<!--        <el-col :span="6">-->
<!--          <el-input v-model="activitiesSignUpManageInfo.conditions.activitiesId" :placeholder="$t('activitiesSignUpManage.search.activitiesId')" clearable />-->
<!--        </el-col>-->
        <el-col :span="4">
          <el-select v-model="activitiesSignUpManageInfo.conditions.state" :placeholder="$t('activitiesSignUpManage.search.state')" style="width:100%">
<!--            <el-option v-for="item in activitiesSignUpManageInfo.typeCds" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />-->
            <el-option :key="'10000'" :value="'10000'" label="已报名" />
            <el-option :key="'11000'" :value="'11000'" label="已取消" />
            <el-option :key="'12000'" :value="'12000'" label="已完成" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryActivitiesMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetActivitiesMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
      <el-row v-if="activitiesSignUpManageInfo.moreCondition" :gutter="20" style="margin-top:15px">
        <el-col :span="6">
          <el-date-picker v-model="activitiesSignUpManageInfo.conditions.startTime"
            :placeholder="$t('activitiesSignUpManage.search.startTime')"
            type="date"
            value-format="yyyy-MM-dd"
            clearable />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="activitiesSignUpManageInfo.conditions.endTime"
            :placeholder="$t('activitiesSignUpManage.search.endTime')"
            type="date"
            value-format="yyyy-MM-dd"
            clearable />
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('activitiesSignUpManage.list.title') }}</span>
<!--        <el-button type="primary" size="small" @click="_openAddActivitiesModal">-->
<!--          <i class="el-icon-plus"></i>-->
<!--          {{ $t('common.add') }}-->
<!--        </el-button>-->
      </div>
      <el-table :data="activitiesSignUpManageInfo.activitiesSignUps" border style="width: 100%">
        <el-table-column prop="signUpId" :label="$t('activitiesSignUpManage.table.signUpId')" align="center" />
<!--        <el-table-column prop="activitiesId" :label="$t('activitiesSignUpManage.table.activitiesId')" align="center" />-->
        <el-table-column prop="activitiesTitle" :label="$t('activitiesSignUpManage.table.activitiesTitle')" align="center" />
        <el-table-column prop="userName" :label="$t('activitiesSignUpManage.table.userName')" align="center" />
        <el-table-column prop="userTel" :label="$t('activitiesSignUpManage.table.userTel')" align="center" />
        <el-table-column prop="peopleCount" :label="$t('activitiesSignUpManage.table.peopleCount')" align="center" />
        <el-table-column :label="$t('activitiesSignUpManage.table.payAmount')" align="center">
          <template slot-scope="scope">
            {{ formatPayAmount(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('activitiesSignUpManage.table.stateName')" align="center" />
        <el-table-column prop="createTime" :label="$t('activitiesSignUpManage.table.createTime')" align="center" />

        <!-- <el-table-column prop="title" :label="$t('activitiesSignUpManage.table.title')" align="center" /> -->
        <!-- <el-table-column prop="typeCdName" :label="$t('activitiesSignUpManage.table.typeCd')" align="center" /> -->
        <!-- <el-table-column prop="startTime" :label="$t('activitiesSignUpManage.table.startTime')" align="center" /> -->
        <!-- <el-table-column prop="endTime" :label="$t('activitiesSignUpManage.table.endTime')" align="center" /> -->
        <!-- <el-table-column prop="userName" :label="$t('activitiesSignUpManage.table.userName')" align="center" /> -->
        <el-table-column :label="$t('common.operation')" align="center" width="260">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="_openDetailActivitiesSignUpModel(scope.row)">
              {{ $t('common.detail') }}
            </el-button>
            <el-button v-if="scope.row.state == '10000'" size="mini" @click="_openEditActivitiesModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button v-if="false" size="mini" type="danger" @click="_openDeleteActivitiesModel(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top:20px;text-align:right" />
    </el-card>

<!--    <add-activities-view ref="addActivitiesView" @success="handleSuccess" />-->
    <edit-activities-sign-up-view ref="editActivitiesSignUpView" @success="handleSuccess" />
    <detail-activities-sign-up-view ref="detailActivitiesSignUpView" />
    <delete-activities-sign-up ref="deleteActivitiesSignUp" @success="handleSuccess" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listActivitiesSignUp, listActivitiesType } from '@/api/oa/activitiesSignUpManageApi'
// import AddActivitiesView from '@/components/oa/addActivitiesView'
import EditActivitiesSignUpView from '@/components/oa/editActivitiesSignUpView'
import DetailActivitiesSignUpView from '@/components/oa/detailActivitiesSignUpView'
import DeleteActivitiesSignUp from '@/components/oa/deleteActivitiesSignUp'

export default {
  name: 'ActivitiesSignUpManageList',
  components: {
    // AddActivitiesView,
    EditActivitiesSignUpView,
    DetailActivitiesSignUpView,
    DeleteActivitiesSignUp
  },
  data() {
    return {
      activitiesSignUpManageInfo: {
        activitiesSignUps: [],
        total: 0,
        records: 1,
        moreCondition: false,
        title: '',
        typeCds: [],
        conditions: {
          userName:'',
          userTel:'',
          peopleCount:'',
          state:'',
          activitiesTitle: '',
          typeCd: '',
          staffName: '',
          activitiesId: '',
          endTimeFlag: '1',
          page: 1,
          row: 10,
          communityId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.activitiesSignUpManageInfo.conditions.communityId = this.communityId
    this._listActivitiesSignUps()
    this._loadActivitiesType()
  },
  methods: {
    formatPayAmount(row) {
      if (row.isCharge !== 'Y') {
        return '-'
      }
      if (row.payAmount === null || row.payAmount === undefined || row.payAmount === '') {
        return '-'
      }
      return `${row.payAmount}元`
    },
    async _listActivitiesSignUps() {
      try {
        const params = {
          ...this.activitiesSignUpManageInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listActivitiesSignUp(params)
        this.activitiesSignUpManageInfo.activitiesSignUps = data
        this.page.total = total
      } catch (error) {
        console.error('获取活动列表失败:', error)
      }
    },
    async _loadActivitiesType() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: this.communityId
        }
        const { data } = await listActivitiesType(params)
        this.activitiesSignUpManageInfo.typeCds = data
      } catch (error) {
        console.error('获取活动类型失败:', error)
      }
    },
    _openAddActivitiesModal() {
      this.$refs.addActivitiesView.open()
    },
    _openEditActivitiesModel(row) {
      this.$refs.editActivitiesSignUpView.open(row)
    },
    _openDetailActivitiesSignUpModel(row) {
      this.$refs.detailActivitiesSignUpView.open(row)
    },
    _openDeleteActivitiesModel(row) {
      this.$refs.deleteActivitiesSignUp.open(row)
    },
    _queryActivitiesMethod() {
      this.page.current = 1
      this._listActivitiesSignUps()
    },
    _resetActivitiesMethod() {
      this.activitiesSignUpManageInfo.conditions = {
        userName: '',
        userTel: '',
        peopleCount: '',
        state: '',
        activitiesTitle: '',
        typeCd: '',
        staffName: '',
        activitiesId: '',
        endTimeFlag: '1',
        page: 1,
        row: 10,
        communityId: this.communityId
      }
      this.page.current = 1
      this._listActivitiesSignUps()
    },
    _moreCondition() {
      this.activitiesSignUpManageInfo.moreCondition = !this.activitiesSignUpManageInfo.moreCondition
    },
    handleSuccess() {
      this._listActivitiesSignUps()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listActivitiesSignUps()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listActivitiesSignUps()
    }
  }
}
</script>

<style lang="scss" scoped>
.activities-manage-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .no_display {
    display: none;
  }
}
</style>